class WallpaperCalculatorElement extends HTMLElement {
    connectedCallback() {
        this.init();
        this.registerVariantAddListener();
    }

    init() {
        this.heightInput = this.querySelector('input[name="wc-height"]');
        this.widthInput = this.querySelector('input[name="wc-width"]');
        this.resultOutput = this.querySelector('.wallpaper-calculator__results');
        this.button = this.querySelector('button[name="wc-button"]');

        this.quantityLip = this.querySelector('.wallpaper-calculator__quantity-lip');
        this.widthLip = this.querySelector('.wallpaper-calculator__width-lip');
        this.heightLip = this.querySelector('.wallpaper-calculator__height-lip');
        this.squareMeterLip = this.querySelector('.wallpaper-calculator__square-meter-lip');
        this.idLip = this.querySelector('.wallpaper-calculator__id-lip');

        this.addToCartButtonContainer = this.querySelector('.wallpaper-calculator__action-add-to-cart');
        this.addToCartButton = this.addToCartButtonContainer.querySelector('button[type="submit"]');

        this.calcButtonContainer = this.querySelector('.wallpaper-calculator__action-calc');
        this.calcButton = this.calcButtonContainer.querySelector('button[name="wc-button"]');

        this.pricePerUnit = parseFloat(this.dataset.price);
        this.comparePricePerUnit = parseFloat(this.dataset.compareAtPrice);

        this.priceBlock = document.querySelector('[data-block-id="price"][data-block-type="price"]');
        if (!this.priceBlock) return;

        this.salePriceEl = this.priceBlock.querySelector('sale-price');
        this.comparePriceEl = this.priceBlock.querySelector('compare-at-price');
        this.badgeEl = this.priceBlock.querySelector('on-sale-badge');

        // Speichere die ursprünglichen Werte für den Vergleich
        this.originalHeight = this.heightInput?.value || '';
        this.originalWidth = this.widthInput?.value || '';

        // Event-Listener für Änderungen an den Input-Feldern
        this.heightInput?.addEventListener('input', () => this.handleInputChange());
        this.widthInput?.addEventListener('input', () => this.handleInputChange());

        this.button?.addEventListener('click', () => {
            const height = parseFloat(this.heightInput?.value);
            const width = parseFloat(this.widthInput?.value);

            if (!this.isValid(height, width)) {
                console.log('Bitte gültige Werte eingeben.')
                return;
            }

            this.addToCartButtonContainer.classList.add('is-hidden');

            // Ladezustand aktivieren
            this.button.setAttribute('aria-busy', 'true');
            this.resultOutput.classList.add('hidden'); // Ergebnis vorerst verstecken

            // 2 Sekunden warten (Berechnung "simulieren")
            setTimeout(() => {
                const sqm = this.calculateSquareMeters(height, width);
                const finalPrice = sqm * this.pricePerUnit;

                // Ergebnis anzeigen
                this.resultOutput.classList.remove('hidden');

                // Versteckte Felder setzen
                if (this.quantityLip) this.quantityLip.value = Math.ceil(sqm);
                if (this.widthLip) this.widthLip.value = width.toString();
                if (this.heightLip) this.heightLip.value = height.toString();
                if (this.squareMeterLip) this.squareMeterLip.value = Math.ceil(sqm);
                this.setTwpcId(width, height, sqm);

                // Preise aktualisieren
                this.setPriceText(this.salePriceEl, this.formatEuro(finalPrice));
                this.setPriceText(this.resultOutput, this.formatEuro(finalPrice));

                if (!isNaN(this.comparePricePerUnit) && this.comparePricePerUnit > this.pricePerUnit) {
                    const originalPrice = sqm * this.comparePricePerUnit;
                    this.setPriceText(this.comparePriceEl, this.formatEuro(originalPrice));
                    this.setPriceText(this.badgeEl, this.formatEuro(originalPrice - finalPrice));
                } else {
                    this.setPriceText(this.comparePriceEl, '');
                    this.setPriceText(this.badgeEl, '');
                }

                // Ladezustand wieder deaktivieren
                this.button.setAttribute('aria-busy', 'false');

                this.calcButtonContainer.classList.add('is-hidden');
                this.addToCartButtonContainer.classList.remove('is-hidden');

                // Aktualisiere die ursprünglichen Werte nach der Berechnung
                this.originalHeight = this.heightInput?.value || '';
                this.originalWidth = this.widthInput?.value || '';
            }, 1000);
        });
    }

    handleInputChange() {
        const currentHeight = this.heightInput?.value || '';
        const currentWidth = this.widthInput?.value || '';

        // Prüfe, ob sich die Werte geändert haben
        if (currentHeight !== this.originalHeight || currentWidth !== this.originalWidth) {
            // Zeige den Calc-Button wieder an und verstecke den Add-to-Cart-Button
            this.calcButtonContainer.classList.remove('is-hidden');
            this.addToCartButtonContainer.classList.add('is-hidden');
            
            // Verstecke das Ergebnis
            this.resultOutput.classList.add('hidden');
        }
    }

    setTwpcId(width, height, sqm) {
        if (!this.idLip) return;
        this.idLip.value = this.generateReadableId(width, height, sqm);
    }

    generateReadableId(width, height, sqm) {
        const timestamp = Math.floor(Date.now() / 1000); // UNIX-Timestamp in Sekunden
        const idWidth = Math.round(width);
        const idHeight = Math.round(height);
        const idSqm = Math.ceil(sqm);

        return `twpc_${idWidth}x${idHeight}_${idSqm}_${timestamp}`;
    }

    calculateSquareMeters(heightCm, widthCm) {
        const area = (heightCm / 100) * (widthCm / 100);
        return Math.ceil(area);
    }

    formatEuro(value) {
        return value.toLocaleString('de-DE', {
            style: 'currency',
            currency: 'EUR'
        });
    }

    setPriceText(el, value) {
        if (!el) return;
        const priceSpan = el.querySelector('.price');
        if (priceSpan) {
            priceSpan.textContent = value;
        }
    }

    isValid(height, width) {
        return !isNaN(height) && !isNaN(width) && height > 0 && width > 0;
    }

    registerVariantAddListener() {
        document.addEventListener('variant:add', () => {
            if (!this.heightInput || !this.widthInput || !this.idLip) return;

            const height = parseFloat(this.heightInput.value);
            const width = parseFloat(this.widthInput.value);
            if (!this.isValid(height, width)) return;

            const sqm = this.calculateSquareMeters(height, width);
            this.setTwpcId(width, height, sqm);
        });
    }
}

customElements.define('wallpaper-calculator', WallpaperCalculatorElement);